/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Token metadata and links
 * @export
 * @interface CoinInsightsExtensions
 */
export interface CoinInsightsExtensions {
    /**
     * CoinGecko ID
     * @type {string}
     * @memberof CoinInsightsExtensions
     */
    coingeckoId?: string;
    /**
     * Token description
     * @type {string}
     * @memberof CoinInsightsExtensions
     */
    description?: string;
    /**
     * Twitter URL
     * @type {string}
     * @memberof CoinInsightsExtensions
     */
    twitter?: string;
    /**
     * Website URL
     * @type {string}
     * @memberof CoinInsightsExtensions
     */
    website?: string;
    /**
     * Discord invite URL
     * @type {string}
     * @memberof CoinInsightsExtensions
     */
    discord?: string;
}

/**
 * Check if a given object implements the CoinInsightsExtensions interface.
 */
export function instanceOfCoinInsightsExtensions(value: object): value is CoinInsightsExtensions {
    let isInstance = true;

    return isInstance;
}

export function CoinInsightsExtensionsFromJSON(json: any): CoinInsightsExtensions {
    return CoinInsightsExtensionsFromJSONTyped(json, false);
}

export function CoinInsightsExtensionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CoinInsightsExtensions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'coingeckoId': !exists(json, 'coingeckoId') ? undefined : json['coingeckoId'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'twitter': !exists(json, 'twitter') ? undefined : json['twitter'],
        'website': !exists(json, 'website') ? undefined : json['website'],
        'discord': !exists(json, 'discord') ? undefined : json['discord'],
    };
}

export function CoinInsightsExtensionsToJSON(value?: CoinInsightsExtensions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'coingeckoId': value.coingeckoId,
        'description': value.description,
        'twitter': value.twitter,
        'website': value.website,
        'discord': value.discord,
    };
}

